module.exports = __webpack_public_path__ + "img/A58A2988.a9e6a10e.jpg";